// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ManualPenaltyListSM from "../../app/state-machine/ManualPenaltyListSM.bs.js";
import * as CreateManualPenaltyForm from "./CreateManualPenaltyForm.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as OrderAndPartnerIDFormCmp from "./OrderAndPartnerIDFormCmp.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as PartnerPenaltyDataMachine from "../../app/data-machine/PartnerPenaltyDataMachine.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as CreateManualPenaltyVMMapper from "../vm-mapper/CreateManualPenaltyVMMapper.bs.js";
import * as PartnerPenaltyAssetsManager from "../assets/PartnerPenaltyAssetsManager.bs.js";

PartnerPenaltyAssetsManager.importCss(undefined);

function CreateManualPenaltyCmp(Props) {
  var orderId = Props.orderId;
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  var match$1 = ToastSnackbarHook$Catalyst.useSnackbar(undefined, undefined, undefined);
  var openSnackbar = match$1[1];
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var match$2 = React.useReducer(ManualPenaltyListSM.machine, /* Init */0);
  var penaltyListDispatch = match$2[1];
  var penaltyListState = match$2[0];
  var createManualPenalty = function (msisdn, crn, penalty_id) {
    return PartnerPenaltyDataMachine.createManualPenalty({
                msisdn: msisdn,
                order_id: crn,
                penalty_enum_id: penalty_id
              }, country, (function (param) {
                  return Curry._2(workspaceDispatch.addTab, {
                              TAG: /* DriverPenalties */18,
                              _0: msisdn,
                              _1: crn
                            }, false);
                }), (function (error) {
                  return Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                }));
  };
  var form = CreateManualPenaltyForm.Form.useForm({
        crn: orderId,
        msisdn: Belt_Option.getWithDefault(msisdn, ""),
        penalty_type: undefined
      }, {
        country: country
      }, (function (output, submissionCallbacks) {
          createManualPenalty(output.msisdn, output.crn, output.penalty_type);
          return Curry._1(submissionCallbacks.notifyOnSuccess, undefined);
        }));
  var resetPenaltyList = function (param) {
    return Curry._1(penaltyListDispatch, /* SetToLodingState */0);
  };
  var tmp;
  if (typeof penaltyListState === "number" || penaltyListState.TAG !== /* Data */0) {
    tmp = null;
  } else {
    var createPenaltyVM = CreateManualPenaltyVMMapper.getVM(penaltyListState._0);
    tmp = React.createElement(React.Fragment, undefined, $$Array.map((function (details) {
                return React.createElement(Row$Catalyst.make, {
                            children: null,
                            className: "text-wrapper"
                          }, React.createElement("div", {
                                className: "label"
                              }, details.label), React.createElement("div", {
                                className: "value"
                              }, details.value));
              }), createPenaltyVM.orderDetailsVMList), React.createElement(Column$Catalyst.make, {
              children: null,
              className: "input-text-wrapper"
            }, React.createElement("label", {
                  className: "label"
                }, "Penalty Type"), React.createElement(FormSelectInput$Catalyst.make, {
                  input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                          return Curry._2(form.updatePenalty_type, (function (input, value) {
                                        return {
                                                crn: input.crn,
                                                msisdn: input.msisdn,
                                                penalty_type: value
                                              };
                                      }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), createPenaltyVM.penaltyTypeOptions));
                        }), undefined, undefined, "Select Penalty", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                  select_props: {
                    value: form.input.penalty_type,
                    items: createPenaltyVM.penaltyTypeOptions,
                    isNoneRequired: false
                  }
                })), React.createElement(Button$Catalyst.make, {
              text: "Create Manual Penalty",
              cb: (function (param) {
                  return Curry._1(form.submit, undefined);
                }),
              className: "submit-btn"
            }));
  }
  return React.createElement("div", {
              className: "c-create-manual-penalty"
            }, React.createElement("div", {
                  className: "title"
                }, "ASSIGN MANUAL PENALTY"), React.createElement(OrderAndPartnerIDFormCmp.make, {
                  form: form,
                  resetPenaltyList: resetPenaltyList
                }), React.createElement(Button$Catalyst.make, {
                  text: "Fetch Penalty List",
                  cb: (function (param) {
                      Curry._1(penaltyListDispatch, /* SetToLodingState */0);
                      return PartnerPenaltyDataMachine.fetchManualPenaltyList(orderId, form.input.msisdn, country, (function (data) {
                                    return Curry._1(penaltyListDispatch, {
                                                TAG: /* FetchManualPenaltyListSuccess */0,
                                                _0: data
                                              });
                                  }), (function (error) {
                                    Curry._1(penaltyListDispatch, {
                                          TAG: /* FetchManualPenaltyListFailure */1,
                                          _0: error
                                        });
                                    return Curry._1(openSnackbar, {
                                                TAG: /* Error */1,
                                                _0: ErrorUtils$Catalyst.resolveError(error)
                                              });
                                  }));
                    }),
                  className: "submit-btn"
                }), tmp, match$1[0]);
}

var make = CreateManualPenaltyCmp;

export {
  make ,
  
}
/*  Not a pure module */
